import React from 'react';

import { ErrorStatus } from '../../shared/enum/ErrorStatus';
import { newsModelInitial } from '../../Models/InfluencerModel';
import { VehicleModel, vehicleModelInitial } from '../../Models/VehicleModel';
import { ClassificationModel, classificationModelInitial } from '../../Models/ClassificationModel';
import { DetachedClassificationAction } from './enum/DetachedClassificationAction';
import { InfluencerModel } from '../../Models/InfluencerModel';

export interface INewsContextProps {
    news: InfluencerModel,
    setNews: (news: InfluencerModel) => void,
    questions:  Record<string, any>,
    setQuestions: (questions:any) => void,
    errorQuestions:  Record<string, any>,
    setErrorQuestions: (questions:any) => void,
    statusClassification:  Record<string, any>,
    setStatusClassification: (questions:any) => void,
    newsList: InfluencerModel[],
    setNewsList: (news: InfluencerModel[]) => void,
    newsIndex: number,
    setNewsIndex: (index: number) => void,
    newsCurrentId: number | null,
    setNewsCurrentId: (currentId: number | null) => void,
    vehicle: VehicleModel,
    setVehicle: (vehicle: VehicleModel) => void,
    vehicleMetricCorrect: boolean,
    setVehicleMetricCorrect: (correct: boolean) => void,
    errorDataStatus: ErrorStatus,
    setErrorDataStatus: (errorStatus: ErrorStatus) => void,
    errorCategorizationStatus: ErrorStatus,
    setErrorCategorizationStatus: (errorStatus: ErrorStatus) => void,
    errorAtLeastOneCategorizationStatus: ErrorStatus,
    setErrorAtLeastOneCategorizationStatus: (errorStatus: ErrorStatus) => void,
    listNewsPending: InfluencerModel[],
    setListNewsPending: (news: InfluencerModel[]) => void,
    keepData: boolean,
    setKeepData: (value: boolean) => void,
    classification: ClassificationModel,
    setClassification: (classification: ClassificationModel) => void,
    tabListSelected: number,
    setTabListSelected: (tab: number) => void,
    detachedNewsDataAction: DetachedClassificationAction,
    setDetachedNewsDataAction: (action: DetachedClassificationAction) => void,
    detachedNewsCategorizationAction: DetachedClassificationAction,
    setDetachedNewsCategorizationAction: (action: DetachedClassificationAction) => void
}

export const newsContextInitial: INewsContextProps = {
    news: newsModelInitial,
    setNews: () => { ''; },
    newsList: [],
    setNewsList: () => { ''; },
    questions: [],
    setQuestions: () => { ''; },
    errorQuestions: [],
    setErrorQuestions: ()=>{'';},
    statusClassification: [],
    setStatusClassification: () => { ''; },
    newsIndex: -1,
    setNewsIndex: () => { ''; },
    newsCurrentId: 0,
    setNewsCurrentId: () => { ''; },
    vehicle: vehicleModelInitial,
    setVehicle: () => { ''; },
    vehicleMetricCorrect: false,
    setVehicleMetricCorrect: () => { ''; },
    errorDataStatus: ErrorStatus.NOT_INICIALIZED,
    setErrorDataStatus: () => { ''; },
    errorCategorizationStatus: ErrorStatus.NOT_INICIALIZED,
    setErrorCategorizationStatus: () => { ''; },
    errorAtLeastOneCategorizationStatus: ErrorStatus.NOT_INICIALIZED,
    setErrorAtLeastOneCategorizationStatus: () => { ''; },
    listNewsPending: [],
    setListNewsPending: () => { ''; },
    keepData: false,
    setKeepData: () => { ''; },
    classification: classificationModelInitial,
    setClassification: () => { ''; },    
    tabListSelected: 0,
    setTabListSelected: () => { ''; },
    detachedNewsDataAction: DetachedClassificationAction.NONE,
    setDetachedNewsDataAction: () => { ''; },
    detachedNewsCategorizationAction: DetachedClassificationAction.NONE,
    setDetachedNewsCategorizationAction: () => { ''; }
};

export const InfluencerContext = React.createContext(newsContextInitial);



